import {TeamEvent} from './TeamEvent';

export class TeamUpdated extends TeamEvent {}
